/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentActions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAppointment from './CancelAppointment/index'
import CancelCheckIn from './CancelCheckIn/index'
import CancelCheckout from './CancelCheckout/index'
import CancelNoShow from './CancelNoShow/index'
import CancelSeating from './CancelSeating/index'
import CancelUnseating from './CancelUnseating/index'
import CheckInPatient from './CheckInPatient/index'
import Checkout from './Checkout/index'
import DeleteAppointment from './DeleteAppointment/index'
import EditOrRescheduleAppointment from './EditOrRescheduleAppointment/index'
import MarkAsConfirmed from './MarkAsConfirmed/index'
import MarkAsNoShow from './MarkAsNoShow/index'
import PrintAppointmentSlip from './PrintAppointmentSlip/index'
import React from 'react'
import RescheduleAppointment from './RescheduleAppointment/index'
import ScheduleViaSMSOrEmail from './ScheduleViaSMSOrEmail/index'
import Seat from './Seat/index'
import Unseat from './Unseat/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentActions({
  children,
  viewPath = "/DesignSystem/AppointmentActions"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="AppointmentActions.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-EYSPt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<CheckInPatient
  viewPath={`${viewPath}/CheckInPatient`}
/>
<MarkAsConfirmed
  viewPath={`${viewPath}/MarkAsConfirmed`}
/>
<Seat
  viewPath={`${viewPath}/Seat`}
/>
<CancelCheckIn
  viewPath={`${viewPath}/CancelCheckIn`}
/>
<Unseat
  viewPath={`${viewPath}/Unseat`}
/>
<CancelSeating
  viewPath={`${viewPath}/CancelSeating`}
/>
<Checkout
  viewPath={`${viewPath}/Checkout`}
/>
<CancelUnseating
  viewPath={`${viewPath}/CancelUnseating`}
/>
<CancelCheckout
  viewPath={`${viewPath}/CancelCheckout`}
/>
<RescheduleAppointment
  viewPath={`${viewPath}/RescheduleAppointment`}
/>
<ScheduleViaSMSOrEmail
  viewPath={`${viewPath}/ScheduleViaSMSOrEmail`}
/>
<EditOrRescheduleAppointment
  viewPath={`${viewPath}/EditOrRescheduleAppointment`}
/>
<MarkAsNoShow
  viewPath={`${viewPath}/MarkAsNoShow`}
/>
<CancelAppointment
  viewPath={`${viewPath}/CancelAppointment`}
/>
<CancelNoShow
  viewPath={`${viewPath}/CancelNoShow`}
/>
<PrintAppointmentSlip
  viewPath={`${viewPath}/PrintAppointmentSlip`}
/>
<DeleteAppointment
  viewPath={`${viewPath}/DeleteAppointment`}
/>
</div>
{children}
</React.Fragment>)
}